module.exports = __webpack_public_path__ + "static/Giulia_Bertario-6ca0315efbfbfdd914d8e4739b27af71.jpg";